import { SelectDateRange } from "Components/Calendar/context"
import moment from "moment"
import { PushBoard } from "Types/board"
import { timeFormatStr } from "Methods/basic"

export const generateBoardTime = (data: PushBoard | null) => {
    if (data) {
        const times = []
        for (const d of data.ad_times) {
            times.push(new Date(d))
        }
        return times
    } else {
        return []
    }
}
// 多条预约时的时间范围字符串
export const generateModalTimeStr = (selectDateRange: SelectDateRange | null) => {
    let modalTimeStr = ""
    const adTimes: Date[] = []
    if (!selectDateRange) {
        return {
            adTimes: [],
            modalTimeStr: "",
        }
    }
    const dateRange = selectDateRange as SelectDateRange
    const startTime = Math.min(dateRange.start.getTime(), dateRange.end.getTime())
    const endTime = Math.max(dateRange.start.getTime(), dateRange.end.getTime())
    const startDate = new Date(startTime)
    const endDate = new Date(endTime)
    const startDay = startDate.getDay() || 7
    const endDay = endDate.getDay() || 7
    if (startTime === endTime) {
        modalTimeStr = `${moment(startDate).format(timeFormatStr.month)}`
    } else {
        modalTimeStr = `${moment(startDate).format(timeFormatStr.month)} - ${moment(endDate).format(timeFormatStr.month)}`
    }
    for (let i = 0; i <= endDay - startDay; i++) {
        adTimes.push(new Date(startTime + (i * 1000 * 3600 * 24)))
    }
    return { modalTimeStr, adTimes }
}
